// authentication/components/TermsModal/index.jsx

import React from "react";
import { Modal, Button } from "react-bootstrap";
import styles from "./styles.module.css";
import {
  FileEarmarkText,
  UiChecksGrid,
  PersonVcard,
  Lock,
  Globe,
  ShieldCheck,
  ExclamationTriangle,
  JournalCheck,
  BoxArrowInUpRight,
  FileText,
  Telephone
} from "react-bootstrap-icons";

// Estrutura de dados para o conteúdo dos termos, facilitando a manutenção
const termsSections = [
  {
    icon: <FileEarmarkText size={24} className={styles.sectionIcon} />,
    title: "1. Sobre a Vertex 4D",
    content: (
      <p>
        A Vertex 4D oferece uma plataforma inovadora para visualização e análise
        com foco em automação, precisão e flexibilidade. Utilizamos{" "}
        <strong>Inteligência Artificial</strong>, drones, aerofotogrametria e
        processamento automatizado de imagens para fornecer soluções avançadas
        em <strong>visualização 360 graus</strong>,{" "}
        <strong>modelagem 3D</strong> e <strong>análise de dados</strong>. Nossa
        missão é transformar as imagens capturadas em{" "}
        <strong>modelos 3D de alta precisão</strong>, promovendo insights
        valiosos para auxiliar na tomada de decisões.
      </p>
    )
  },
  {
    icon: <UiChecksGrid size={24} className={styles.sectionIcon} />,
    title: "2. Escopo dos Serviços",
    content: (
      <ul>
        <li>
          <strong>Visualização 360 graus e Modelagem 3D Automatizada:</strong>{" "}
          Através de nossa plataforma, você poderá visualizar{" "}
          <strong>modelos 3D detalhados</strong> e imagens panorâmicas com
          precisão aerofotogramétrica.
        </li>
        <li>
          <strong>Relatórios Automatizados:</strong> Fornecemos relatórios
          detalhados com <strong>dados precisos</strong> para suportar o
          processo decisório.
        </li>
        <li>
          <strong>Marketplace para Serviços de Captura:</strong> Nossa
          plataforma permite que você solicite{" "}
          <strong>serviços de captura de imagens por drones</strong> em qualquer
          lugar do Brasil. Conectamos você a parceiros certificados para uma
          coleta de dados segura e eficiente.
        </li>
      </ul>
    )
  },
  {
    icon: <PersonVcard size={24} className={styles.sectionIcon} />,
    title: "3. Cadastro e Acesso à Plataforma",
    content: (
      <>
        <p>
          Para utilizar a Vertex 4D, é necessário que você crie uma conta
          fornecendo <strong>informações precisas e atualizadas</strong>. O
          acesso à plataforma é exclusivo ao usuário cadastrado, e qualquer
          atividade realizada em sua conta será de sua responsabilidade.
        </p>
        <p>
          <strong>Responsabilidades do Usuário:</strong>
        </p>
        <ul>
          <li>
            <strong>Proteger suas credenciais de login.</strong>
          </li>
          <li>
            <strong>Notificar imediatamente a Vertex 4D</strong> em caso de
            suspeita de acesso não autorizado.
          </li>
          <li>
            Fornecer <strong>informações corretas durante o cadastro</strong>.
          </li>
        </ul>
      </>
    )
  },
  {
    icon: <Lock size={24} className={styles.sectionIcon} />,
    title: "4. Uso Permitido e Restrito",
    content: (
      <>
        <p>
          Os serviços da Vertex 4D devem ser utilizados de acordo com os fins
          permitidos nestes Termos:
        </p>
        <ul>
          <li>
            <strong>Uso Permitido:</strong> Visualização de imagens 360 graus,
            geração de modelos 3D, solicitação de serviços de captura de imagens
            e geração de relatórios para fins de análise.
          </li>
          <li>
            <strong>Uso Restrito:</strong> É proibido o uso de nossa plataforma
            para fins ilícitos, como extração massiva de dados, cópia de
            conteúdo protegido, ou qualquer outra finalidade que infrinja os
            direitos da Vertex 4D ou de terceiros.
          </li>
        </ul>
      </>
    )
  },
  {
    icon: <Globe size={24} className={styles.sectionIcon} />,
    title: "5. Propriedade Intelectual",
    content: (
      <p>
        Todo o conteúdo e tecnologia fornecidos pela Vertex 4D, incluindo
        imagens, modelos 3D, relatórios, software e marca, são protegidos por
        <strong> direitos de propriedade intelectual</strong>. O usuário está
        autorizado a utilizar o conteúdo fornecido apenas para fins específicos
        da plataforma e é proibida a{" "}
        <strong>
          reprodução, redistribuição ou comercialização não autorizada
        </strong>
        .
      </p>
    )
  },
  {
    icon: <ShieldCheck size={24} className={styles.sectionIcon} />,
    title: "6. Política de Privacidade",
    content: (
      <p>
        Coletamos e tratamos <strong>dados pessoais</strong> conforme nossa{" "}
        <strong>Política de Privacidade</strong>. Ao utilizar nossos serviços,
        você concorda com a coleta, uso e compartilhamento de seus dados
        pessoais conforme descrito em nossa Política de Privacidade.
      </p>
    )
  },
  {
    icon: <ExclamationTriangle size={24} className={styles.sectionIcon} />,
    title: "7. Responsabilidades e Limitação de Garantia",
    content: (
      <>
        <p>
          <strong>Precisão dos Dados:</strong> A Vertex 4D emprega esforços para
          garantir que as imagens e dados gerados sejam precisos. Contudo,{" "}
          <strong>
            não garantimos que os serviços serão ininterruptos ou livres de
            erros
          </strong>
          .
        </p>
        <p>
          <strong>Limitação de Responsabilidade:</strong> A Vertex 4D não será
          responsável por danos indiretos, incidentais ou consequenciais,
          incluindo <strong>perda de dados ou lucros</strong>, que possam
          resultar do uso dos nossos serviços.
        </p>
      </>
    )
  },
  {
    icon: <JournalCheck size={24} className={styles.sectionIcon} />,
    title: "8. Solicitações de Captura de Imagem e Relação com Parceiros",
    content: (
      <>
        <p>
          Ao solicitar um serviço de captura de imagens, você concorda que a
          Vertex 4D agirá como <strong>intermediária</strong> entre você e
          nossos parceiros. O serviço poderá estar sujeito a termos adicionais
          com o parceiro responsável pela captura.
        </p>
        <p>
          <strong>Cancelamento de Serviços:</strong> Caso seja necessário
          cancelar uma solicitação de captura de imagens, consulte nossa{" "}
          <strong>Política de Cancelamento</strong>, disponível em nossa
          plataforma.
        </p>
      </>
    )
  },
  {
    icon: <BoxArrowInUpRight size={24} className={styles.sectionIcon} />,
    title: "9. Modificações nos Termos e Encerramento",
    content: (
      <>
        <p>
          A Vertex 4D reserva-se o direito de{" "}
          <strong>modificar estes Termos a qualquer momento</strong>.
          Notificaremos os usuários sobre alterações relevantes, e o uso
          continuado da plataforma após a modificação constitui aceitação dos
          novos Termos.
        </p>
        <p>
          <strong>Encerramento de Conta:</strong> A Vertex 4D pode suspender ou
          encerrar sua conta caso seja detectado uso indevido ou violação destes
          Termos.
        </p>
      </>
    )
  },
  {
    icon: <FileText size={24} className={styles.sectionIcon} />,
    title: "10. Disposições Gerais",
    content: (
      <>
        <p>
          <strong>Legislação Aplicável:</strong> Estes Termos são regidos pela
          legislação brasileira.
        </p>
        <p>
          <strong>Resolução de Conflitos:</strong> Quaisquer disputas
          relacionadas ao uso dos serviços serão resolvidas preferencialmente
          por meios extrajudiciais. Caso não seja possível, o foro da comarca de
          Salvador, Bahia, Brasil será o competente para resolver a questão.
        </p>
        <p>
          <strong>Independência das Cláusulas:</strong> Se qualquer cláusula
          destes Termos for considerada inválida, as demais continuarão em
          vigor.
        </p>
      </>
    )
  },
  {
    icon: <Telephone size={24} className={styles.sectionIcon} />,
    title: "Contato",
    content: (
      <>
        <p>
          Caso tenha dúvidas ou precise de suporte, entre em contato com nossa
          equipe através de <strong>info@vertex4d.ai</strong>.
        </p>
        <p>
          Ao utilizar a Vertex 4D, você reconhece que leu, entendeu e concorda
          em cumprir com os Termos e Condições estabelecidos.
        </p>
      </>
    )
  }
];

const TermsModal = ({ show, onHide }) => {
  return (
    <Modal show={show} onHide={onHide} size="lg" centered>
      <Modal.Header closeButton className={styles.modalHeader}>
        <Modal.Title className={styles.modalTitle}>
          Termos & Condições - Vertex 4D
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className={styles.modalBody}>
        {termsSections.map((section, index) => (
          <div key={index} className={styles.section}>
            <h5 className={styles.sectionTitle}>
              {section.icon}
              {section.title}
            </h5>
            <div className={styles.content}>{section.content}</div>
          </div>
        ))}
      </Modal.Body>
      <Modal.Footer className={styles.modalFooter}>
        <Button variant="secondary" onClick={onHide}>
          Fechar
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default TermsModal;
